import styled from '@emotion/styled';
import { colors, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const MultiRadioWithLabelLi = styled.li`
    && {
        position: relative;
        margin-bottom: ${gutterSizes.xlarge};
    }
`;

export const MultiRadioSwitch = styled.input`
    display: none;

    & + label {
        display: inline-block;
        cursor: pointer;
        font-weight: ${fontWeights.normal};
        width: 100%;
        padding: 0 ${gutterSizes.xxxlarge} 0 0;
        margin-bottom: ${gutterSizes.base};
        position: relative;
        vertical-align: middle;
        white-space: normal;

        &:before {
            content: '';
            background: ${colors.white};
            border-radius: 40px;
            border: 1px solid ${colors.bark40};
            width: 24px;
            height: 24px;
            margin-top: -${gutterSizes.medium};
            position: absolute;
            top: 50%;
            left: auto;
            right: 0;
            vertical-align: middle;
        }
    }

    &:checked + label {
        &:before {
            background: ${colors.green};
            background: radial-gradient(
                ellipse at center,
                ${colors.green} 0,
                ${colors.green} 39%,
                #fff 44%,
                #fff 100%
            );
        }
    }
`;
